import Loadable from 'mk2/helpers/Loadable';

export const InfiniteListLoadable = Loadable({
    loader: () => import('mk2/components/InfiniteList' /* webpackChunkName: "InfiniteList" */).then((mod) => mod.InfiniteList),
    modules: ['mk2/components/InfiniteList'],
    webpack: () => [require.resolveWeak('mk2/components/InfiniteList')],
});
